import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import produce from 'immer';
export const SEARCH_LOCALSTORAGE_KEY = 'academy:search';
export const AI_SEARCH_SESSIONSTORAGE_KEY = 'academy:ai-search';
export const useSearchState = create()(persist(set => ({
  lastClickedSearchResultItem: null,
  setLastClickedSearchResultItem: searchResult => set(produce(state => {
    state.lastClickedSearchResultItem = searchResult;
  })),
  clearLastClickedSearchResultItem: () => set(produce(state => {
    state.lastClickedSearchResultItem = null;
  }))
}), {
  name: SEARCH_LOCALSTORAGE_KEY
}));
export const useAiSearchSessionState = create()(persist(set => ({
  overrideAiSearchEnabled: false,
  setOverrideAiSearchEnabled: enabled => set(produce(state => {
    state.overrideAiSearchEnabled = enabled;
  }))
}), {
  name: AI_SEARCH_SESSIONSTORAGE_KEY,
  storage: createJSONStorage(() => sessionStorage)
}));